import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const DiabetesPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Diabetes</h1>
        <section className="mb-8">
          <p>Diabetes is a metabolic disorder that affects how your body processes blood sugar. Managing diabetes is crucial for long-term health and well-being. While medication is often necessary, natural therapies can support blood sugar control and overall vitality.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Genetic predisposition</li>
            <li>Insulin resistance</li>
            <li>Poor diet and inactivity</li>
            <li>Obesity</li>
            <li>Stress</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Frequent urination</li>
            <li>Excessive thirst</li>
            <li>Unexplained weight loss</li>
            <li>Fatigue</li>
            <li>Blurred vision</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use a blend of traditional herbs, dietary guidance, and lifestyle coaching to help regulate blood sugar naturally. Our holistic philosophy focuses on supporting the pancreas, improving insulin sensitivity, and promoting overall wellness.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Supports healthy blood sugar levels</li>
            <li>Reduces risk of complications</li>
            <li>No harsh side effects</li>
            <li>Encourages healthy lifestyle habits</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat a balanced, low-sugar diet</li>
            <li>Exercise regularly</li>
            <li>Manage stress with yoga or meditation</li>
            <li>Monitor blood sugar consistently</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: Can herbal treatment replace my diabetes medication?</strong>
            <p>A: Herbal therapies can complement your plan, but always consult your doctor before making changes.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this safe for Type 1 and Type 2 diabetes?</strong>
            <p>A: Our approach is most effective for Type 2, but we offer supportive care for all types.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: How soon will I see results?</strong>
            <p>A: Many patients notice improved energy and better sugar control within weeks.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Take charge of your health—book a diabetes wellness consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default DiabetesPage; 